import styled from 'styled-components'
import dsTheme from '../../constants/design-system/theme.json'
import { progressiveBreakpoints } from '../../constants/theme'

const { typography } = dsTheme

export const Header2 = styled.h2`
  ${typography['Kollektif/Large']};
  margin-bottom: 1rem;
  @media ${progressiveBreakpoints.desktopSmall} {
    ${typography['Kollektif/ExtraLarge']};
  }
`

export const SmallHeader2 = styled.h2`
  ${typography['Kollektif/MediumEmphasis']};
  margin-bottom: 1rem;
  @media ${progressiveBreakpoints.desktopSmall} {
    ${typography['Kollektif/Large']};
  }
`

export const Header3 = styled.h3`
  ${typography['Montserrat/MediumEmphasis']};
  margin-bottom: 1rem;
  @media ${progressiveBreakpoints.desktopSmall} {
    ${typography['Montserrat/LargeEmphasis']};
  }
`
